import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { scaleAnimation } from '../../../../utils/keyframes.mjs';
import { ScrollArea } from '../../../scroll-area/ScrollArea.mjs';

const OUT_OFFSET = 20;
const PADDING_X = 40;
const calcMaxHeight = (offset = 0) => `calc(90vh - 70px + ${typeof offset === "string" ? offset : `${offset}px`})`;
const ContentRoot_Legacy = styled("div", {
  width: "100%",
  variants: {
    layout: {
      column: {
        display: "flex"
      }
    }
  }
});
const StyledContent_Legacy = styled(DialogPrimitive.Content, {
  overflow: "hidden",
  backgroundColor: "white",
  borderRadius: 16,
  boxShadow: "$modal",
  display: "flex",
  position: "fixed",
  willChange: "transform, opacity",
  "@motion": {
    '&[data-state="open"]': {
      animationName: scaleAnimation.show(0.98),
      animationDuration: scaleAnimation.duration.open,
      animationTimingFunction: scaleAnimation.timingFunction
    },
    '&[data-state="closed"]': {
      animationName: scaleAnimation.hide(0.99),
      animationDuration: scaleAnimation.duration.close,
      animationTimingFunction: scaleAnimation.timingFunction
    }
  },
  "&:focus": { outline: "none" }
});
const StyledScrollAreaRoot_Legacy = styled(Primitive.div, {
  width: "100%"
});
const StyledScrollAreaViewport_Legacy = styled(
  ScrollArea.Viewport_Legacy,
  {
    minWidth: "520px",
    maxWidth: "600px",
    maxHeight: calcMaxHeight(0),
    width: `calc(100vw - ${OUT_OFFSET * 2}px)`
  }
);
const ChildrenRoot_Legacy = styled("div", {
  display: "flex",
  flexDirection: "column"
});
const StyledFooter_Legacy = styled("footer", {
  width: "100%",
  padding: `0 ${PADDING_X}px 44px`
});

export { ChildrenRoot_Legacy, ContentRoot_Legacy, StyledContent_Legacy, StyledFooter_Legacy, StyledScrollAreaRoot_Legacy, StyledScrollAreaViewport_Legacy };
//# sourceMappingURL=styled.mjs.map
